<template>
  <div>

    <form role="form" v-if="getCriteresRanking">
      <div class="row">
        <div class="col-md-12">
          <b-alert variant="warning" show>
            <u>Critères:</u>
            <br/>
            Pour avoir accès aux Stages Fédéraux Cadets, le(la) compétiteur(trice) doit remplir les critères de sélection ci-dessous. Ces critères de sélection sont basés sur les résultats des douze derniers mois.  <br/>
            <ul>
              <li>Tous les minimes dernière année (nés en {{currentYear()-11}}), licenciés en {{currentYear()}}, de grade A/B qui ont fait premier ou deuxième sur les compétitions ABFT labélisées et qui ont remporté au minimum 1 combat lors du tournoi concerné.</li>
              <li>Tous les cadets licenciés en {{currentYear()}} de grade A/B qui ont fait premier ou deuxième sur les compétitions ABFT labélisées et qui ont remporté au minimum 1 combat lors du tournoi concerné.</li>
              <li>Tous les cadets licenciés en {{currentYear()}} de grade A/B qui ont participé aux compétitions de niveau 2 ou de niveau 3 et qui ont remporté au minimum 1 combat lors du tournoi concerné.</li>
              <li>Tous les juniors première année (nés en {{currentYear()-15}}), licenciés en {{currentYear()}}, de grade A/B qui n’ont pas encore les critères juniors mais qui répondent aux critères ci-dessus.</li>
              <li>Tous les combattants qui ont déjà fait l’objet d’une sélection depuis le 1er janvier {{currentYear()}}, ceci même si le combattant n’est plus actif et/ou que celui-ci ne possède plus de points au ranking.</li>
            </ul>
          </b-alert>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="overlay" v-if="loadingTableCompetitors">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <b-col md="9" class="my-1">
                <h3 class="box-title">{{competitorsFound.length }} compétiteurs</h3>

              </b-col>
              <b-col md="3" class="my-1">
                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
              </b-col>
            </div>
            <div class="box-body">

              <b-table
                id="tableListingStageFormations"
                responsive bordered striped hover
                :items="competitorsFound"
                :fields="columns"
                :filter="filter"
                :current-page="pagination_meta.current_page"
                :per-page="pagination_meta.per_page"
                :sort-compare="sortCompareAdvanced"
                :empty-text="'Aucun résultat'"
                :empty-filtered-text="'Aucun résultat'"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                foot-clone
                show-empty
              >

                <template slot="id" slot-scope="row">
                  {{ row.item.id | idFormat }}
                </template>

                <template slot="nom" slot-scope="row">
                  <router-link
                    :to="{ name: 'Member', params: { member_id: row.item.id }}">
                    {{ row.item.nom}}
                  </router-link>
                </template>

                <template slot="prenom" slot-scope="row">
                  <router-link
                    :to="{ name: 'Member', params: { member_id: row.item.id }}">
                    {{ row.item.prenom}}
                  </router-link>
                </template>

                <template slot="club" slot-scope="row">
                  <router-link :to="{ name: 'Club', params: { club_id: row.item.club.id }}">
                    {{row.item.club.club}}
                  </router-link>
                </template>

                <template slot="age" slot-scope="row">
                  {{ row.item.age }}
                </template>

                <template slot="compte_compet" slot-scope="row">
                  {{ row.item.compte_compet}}
                </template>

                <template slot="cbts_eff" slot-scope="row">
                  {{ row.item.somme_cbts_eff }}
                </template>

                <template slot="cbts_win" slot-scope="row">
                  {{ row.item.somme_cbts_gagnes }}
                </template>

                <template slot="localPoints" slot-scope="row">
                  {{ row.item.localPoints }}
                </template>
                <template slot="totalPoints" slot-scope="row">
                  {{ row.item.totalPoints }}
                </template>

                <template slot="avg_compet" slot-scope="row">
                  {{ row.item.avg_compet }}
                </template>

                <template slot="medailles" slot-scope="row">
                  <div style="min-width:50px;"
                       v-for="(medaille, key) in sortMedaillesByKey(row.item.medailles)"
                       :key="key"
                       class="medal"
                  >
                    <template v-if="key == 'or' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-or"/>
                        {{ medaille }}
                      </a>
                    </template>

                    <template v-if="key == 'arg' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-argent"/>
                        {{ medaille }}
                      </a>
                    </template>


                    <template v-if="key == 'brz' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-bronze"/>
                        {{ medaille }}
                      </a>
                    </template>
                  </div>
                </template>

                <template
                  slot="categPoids"
                  slot-scope="row"
                >
                  <div
                    style="min-width:150px"
                    v-for="categ in groupCategPoids(row.item.categPoids)"
                    :key="
                                                row.item.meta_url +
                                                row.item.place +
                                                categ.id_categ_poids +
                                                categ.id_categ_grade +
                                                categ.id_categ_age
                                            "
                  >
                    {{ getAgeById(categ.id_categ_age).categ_age }}
                    {{ getGradeById(categ.id_categ_grade) ? getGradeById(categ.id_categ_grade).categ_grade.replace('Catégorie', '') : '' }}
                    {{ getPoidsById(categ.id_categ_poids).poids }}
                    ({{ categ.compte }}x)
                    <br/>
                  </div>
                </template>
              </b-table>

              <b-pagination size="md"
                            :total-rows="competitorsFound.length"
                            v-model="pagination_meta.current_page"
                            :per-page="pagination_meta.per_page">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'
    import _ from 'lodash'

    let $ = require('jquery');
    let variables = require('../../../assets/js/variables')
    // var _ = require('underscore')
    let moment = require('moment')
    let FileSaver = require('file-saver');

    export default {
        data() {
            return {
                loadingInputs: [],

                criteres: {
                    sexe: [],
                    age: [],
                    ages: [],
                    grade: [],
                    place: [],
                    niveau: [],
                    competitions: []
                },
                disabledBtn: false,
                resize: false,
                loadingTable: false,
                activeTab: "default",
                redraw: "",
                loadingCriteresBox: false,
                loadingTableCompetitors: false,
                previousRequest: false,
                competitorsFound: [],
                competitorsSelected: [],
                sortBy: 'place',
                sortDesc: false,
                filter: null,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 45,
                    to: 1,
                    total: 1
                },
                columns: [
                    {
                        label: 'Check',
                        key: 'check',
                        sortable: true,
                    },
                    {
                        label: 'Place',
                        key: 'place',
                        sortable: true,
                    },
                    {
                        label: 'Nom',
                        key: 'nom',
                        sortable: true,
                    },
                    {
                        label: 'Prénom',
                        key: 'prenom',
                        sortable: true,
                    },
                    {
                        label: 'Age',
                        key: 'age',
                        sortable: true,
                    },
                    {
                        label: 'Cat. Poids',
                        key: 'categPoids',
                        sortable: true,
                    },
                    {
                        label: 'Médailles',
                        key: 'medailles',
                        sortable: true,
                    },
                    {
                        label: 'Club',
                        key: 'club',
                        sortable: true,
                    },
                    {
                        label: 'Nombre de compétitions',
                        key: 'compte_compet',
                        sortable: true,
                    },
                    {
                        label: 'Nombre de combats effectués',
                        key: 'cbts_eff',
                        sortable: true,
                    },
                    {
                        label: 'Nombre de combats gagnés',
                        key: 'cbts_win',
                        sortable: true,
                    },
                    {
                        label: 'Moyenne par compétition',
                        key: 'avg_compet',
                        sortable: true,
                    },
                    // {
                    //     label: 'Points dans ce ranking',
                    //     key: 'localPoints',
                    //     sortable: true,
                    // },
                    {
                        label: 'Points au ranking ABFT',
                        key: 'totalPoints',
                        sortable: true,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getCriteresRanking: 'getCriteresRanking'
            }),
        },
        mounted: function () {
            let these = this
        },
        created() {
            this.getTableCompetitors();
        },
        beforeRouteEnter(to, from, next) {
            this.getTableCompetitors();
            next()
        },
        watch: {},
        components: {
            vSelect,
        },
        methods: {
            ...mapActions({
                // setFormation: 'setFormation',
                // addMemberToSMS: 'addMemberToSMS',
            }),
            sortMedaillesByKey: function (medailles) {
                return {
                    "or": medailles['or'],
                    "arg": medailles['arg'],
                    "brz": medailles['brz']
                }
            },
            groupCategPoids: function (allCategs) {
                let retour = {}
                let groupe = _.groupBy(allCategs, item => {
                    return (
                        item.id_categ_poids +
                        '*' +
                        item.id_categ_age +
                        '*' +
                        item.id_categ_grade
                    )
                })

                _.forEach(groupe, (item, index) => {
                    retour[index] = {}
                    retour[index]['id_categ_poids'] = groupe[index][0].id_categ_poids
                    retour[index]['id_categ_age'] = groupe[index][0].id_categ_age
                    retour[index]['id_categ_grade'] = groupe[index][0].id_categ_grade
                    retour[index]['compte'] = groupe[index].length
                })
                // debugger
                retour = _.orderBy(
                    retour,
                    item => {
                        return item.compte
                    },
                    ['desc']
                )
                return retour
            },
            getAgeById: function (id) {
                return _.find(this.getCriteresRanking.ages, item => {
                    return item.id == id
                })
            },
            getPoidsById: function (id) {
                return _.find(this.getCriteresRanking.poids, item => {
                    return item.id == id
                })
            },
            getGradeById: function (id) {
                return _.find(this.getCriteresRanking.grades, item => {
                    return item.id == id
                })
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },

            selectAllNiveaux() {

            },
            chunkArrayInGroups(arr, size) {
                let myArray = [];
                for (let i = 0; i < arr.length; i += size) {
                    myArray.push(arr.slice(i, i + size));
                }
                return myArray;
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            currentYear: function () {
                return moment().year();
            },
            getTableCompetitors: function () {
                this.disabledBtn = true;
                this.loadingTableCompetitors = true
                let self = this;
                // console.log(form)
                this.$http.get(this.getRoute('Ranking.getSelectionSFC')).then(function (response) {
                    this.competitorsFound = response.body
                    this.loadingTableCompetitors = false
                }, (response) => {
                    this.$noty.error("Erreur dans la récupération de la sélection SFC")
                    this.loadingTableCompetitors = false
                });
            },
            isTableCompetitorsLoading: function (force = false) {
                if (force)
                    return true
                return this.loadingTableCompetitors;
            },

        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Ranking/SelectionSFC.vue